import { render, staticRenderFns } from "./addProductEntry.vue?vue&type=template&id=5335415c"
import script from "./addProductEntry.vue?vue&type=script&lang=js"
export * from "./addProductEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports